
import { Dialog } from "element-ui"
import { getLanguage } from "@/plugins/i18n"

export default {
  name: "CouponItemDetail",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curVisible: this.visible,
      statusCodeMap: {
        4: "couponUsed",
        8: "couponExpired",
        16: "couponVoided"
      },
      lang: ""
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
    }
  },
  mounted() {
    this.lang = getLanguage()
  },
  methods: {
    formatMainTypeLabel(value = "") {
      if (value === "Market Place Plus Offer") return "yuu Online Shop Offer"
      return value
    },
    formatName(value = "") {
      if (value === "E-Gift Voucher" || value === "電子禮券") return this.$t("coupon.EGiftVoucher")
      if (value === "E-Coupon" || value === "電子現金券") return this.$t("coupon.ECoupon")
      return value
    },
    handleClose() {
      this.$emit("close")
    }
  }
}
